import React from 'react';
import './PageLoader.css';

/**
 * PageLoader — replaces all loading spinners with a pulsing Ceedees logo.
 * Use `fullPage` for auth / route-level loading (centres in the whole viewport).
 * Without `fullPage` it centres within its parent container.
 */
function PageLoader({ fullPage = false }) {
  return (
    <div className={`page-loader ${fullPage ? 'page-loader--full' : ''}`}>
      <div className="page-loader__icon">
        <img src="/emblem-header.png" alt="Loading…" />
      </div>
      <span className="page-loader__text">Loading…</span>
    </div>
  );
}

export default PageLoader;
